import LegalLayout from "@/pages/legal/LegalLayout";

const SECTIONS = [
  {
    id: "introduction",
    label: "Introduction",
    body: [
      "Erenown respects your privacy and is committed to handling personal information responsibly. This Privacy Policy explains how information may be collected, used, and shared in connection with the Erenown website and any enquiries received through it. It is written in plain language and is intended to give a clear, business-appropriate overview of our approach.",
    ],
  },
  {
    id: "who-we-are",
    label: "Who We Are",
    body: [
      "This website presents the wider Erenown structure, which includes independently established Erenown entities in the United Kingdom and Kosovo.",
      "Unless otherwise stated, website operation and legal website disclosures are aligned primarily with Erenown Ltd, registered in England and Wales.",
    ],
  },
  {
    id: "information-we-may-collect",
    label: "Information We May Collect",
    body: [
      "Depending on how the website is used, the information we may collect includes:",
      {
        type: "list",
        items: [
          "name",
          "company or organization name",
          "email address",
          "enquiry information voluntarily submitted through forms or correspondence",
          "any further detail you choose to share",
          "basic website usage information",
          "technical information such as browser, device type, and approximate location, where applicable",
        ],
      },
    ],
  },
  {
    id: "how-we-use-information",
    label: "How We Use Information",
    body: [
      "Information may be used to:",
      {
        type: "list",
        items: [
          "respond to enquiries",
          "manage ongoing communications",
          "improve website functionality and user experience",
          "maintain website security",
          "understand interest in Erenown’s structures, brands, and capabilities",
          "support internal business administration",
        ],
      },
    ],
  },
  {
    id: "legal-basis",
    label: "Legal Basis / Lawful Use",
    body: [
      "Information may be processed where reasonably necessary to respond to enquiries, operate the website, maintain its security, support legitimate business interests, and comply with applicable obligations. Where consent is required by applicable law, we will seek it.",
    ],
  },
  {
    id: "sharing",
    label: "Sharing of Information",
    body: [
      "Erenown does not sell personal data.",
      "Information may be shared with trusted service providers (such as website hosting, email, and analytics infrastructure providers), professional advisers, or where required by law, regulation, or legitimate process. Any such sharing is limited to what is reasonably necessary for the relevant purpose.",
    ],
  },
  {
    id: "international",
    label: "International Aspects",
    body: [
      "Because the wider Erenown structure includes independently established entities in the United Kingdom and Kosovo, and because business activity may involve cross-border coordination, information may be handled across jurisdictions where reasonably necessary and with appropriate care.",
    ],
  },
  {
    id: "retention",
    label: "Data Retention",
    body: [
      "Information is retained only for as long as reasonably necessary for the purpose for which it was collected, for legitimate business records, or to meet applicable compliance needs. When information is no longer required, it is deleted, anonymized, or archived in line with sensible retention practices.",
    ],
  },
  {
    id: "security",
    label: "Data Security",
    body: [
      "We use reasonable administrative, technical, and organizational measures designed to protect information against loss, misuse, and unauthorized access. However, no method of transmission over the internet or electronic storage can be guaranteed to be completely secure.",
    ],
  },
  {
    id: "your-rights",
    label: "Your Rights",
    body: [
      "Depending on applicable law, individuals may have rights relating to access, correction, objection, restriction, deletion, or withdrawal of consent where relevant. Requests can be sent to the contact address below and will be considered in line with applicable obligations.",
    ],
  },
  {
    id: "contact",
    label: "Contact for Privacy Questions",
    body: [
      "For privacy-related questions or requests, please write to:",
      { type: "mono", lines: ["info@erenown.com"] },
    ],
  },
  {
    id: "changes",
    label: "Changes to This Policy",
    body: [
      "This Privacy Policy may be updated from time to time. Revised versions will be posted on the website with an updated effective date. Continued use of the website following any change indicates acceptance of the updated policy.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      eyebrow="Privacy Policy"
      title="Privacy Policy."
      originallyPublished="01 September 2020"
      lastUpdated="16 October 2021"
      intro="A clear, business-facing summary of how the Erenown website collects, uses, and shares information, written in plain language for visitors and enquirers."
      sections={SECTIONS}
    />
  );
}
